export default __webpack_public_path__ + "static/media/checked.a0d44346.svg";